import React from "react";
import background from "../../assets/images/login-background.jpg";

const Background = () => {
  return (
    <>
      <img
        src={background}
        className="absolute w-full h-full"
        alt="Full viewport image"
      />
      <div className="absolute inset-0 bg-black opacity-30"></div>
    </>
  );
};

export default Background;
